import { render, staticRenderFns } from "./PwdStrategy.vue?vue&type=template&id=f7490586&scoped=true&"
import script from "./PwdStrategy.vue?vue&type=script&lang=js&"
export * from "./PwdStrategy.vue?vue&type=script&lang=js&"
import style0 from "./PwdStrategy.vue?vue&type=style&index=0&id=f7490586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7490586",
  null
  
)

export default component.exports